import { Form } from "@inertiajs/react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { adminActAsBrandPath } from "@/routes"

/**
 * OKS-312 — Per-row "Act as {Brand}" entry on `/admin/brands`.
 *
 * Inertia `<Form method="post">` with a hidden `brand_id` input. Locked
 * contract: FLAT body shape (`{ brand_id: <id> }`); the server reads
 * `params[:brand_id]` directly. No nesting — there's no model.
 *
 * Test IDs (UX Spec §2.1):
 *   - `data-testid="admin-brand-act-as-button"` on the form wrapper.
 *   - `data-brand-id={brand.id}` on the form wrapper so Playwright can
 *     target the row for a specific brand.
 */
interface BrandListActAsButtonProps {
  brand: {
    id: number
    name: string
  }
}

export function BrandListActAsButton({ brand }: BrandListActAsButtonProps) {
  const { t } = useTranslation()
  const label = t("admin.act_as.button.act_as", { brand: brand.name })

  return (
    <Form
      action={adminActAsBrandPath()}
      method="post"
      className="inline-flex"
      data-testid="admin-brand-act-as-button"
      data-brand-id={brand.id}
    >
      {({ processing }) => (
        <>
          <input type="hidden" name="brand_id" value={brand.id} />
          <Button
            type="submit"
            size="sm"
            disabled={processing}
            aria-label={label}
          >
            {label}
          </Button>
        </>
      )}
    </Form>
  )
}
